import { render, staticRenderFns } from "./imgY.vue?vue&type=template&id=d1bdb98c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bdb98c')) {
      api.createRecord('d1bdb98c', component.options)
    } else {
      api.reload('d1bdb98c', component.options)
    }
    module.hot.accept("./imgY.vue?vue&type=template&id=d1bdb98c", function () {
      api.rerender('d1bdb98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgY.vue"
export default component.exports